import { Component } from '@angular/core';
import {TrackingHelperService} from "./services/tracking-helper.service";
import {LanguageService} from "./services/language.service";
import {Meta} from "@angular/platform-browser";
import {ConfigService} from "./services/config.service";



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})


export class AppComponent {

  constructor(
    private configs: ConfigService,
    private metaService: Meta,
    private trackingService: TrackingHelperService,
    private langService: LanguageService
  ) {
    this.metaService.addTags([
      {name: 'description', content: this.configs.metaDesc},
      {name: 'author', content: this.configs.brandName},
      {name: 'keywords', content: 'online casino, slots, blackjack, live dealer game, table game, gambling bonuses, poker, free spins, real money, cash rewards, big jackpot, deposit bonus, secure transaction, fast payout, bitcoin payment'}
    ])
    this.langService.initializeLanguage();

    //tracking and analytics
    this.trackingService.setCookiesFromQueryParams();
  }



}
